import * as React from 'react';
import { useRollbar } from '@rollbar/react';

import { trackEvent } from 'utils';

export default function useTrackEvent() {
  const rollbar = useRollbar();

  return {
    trackEvent: React.useCallback(
      (event, payload) => {
        const result = trackEvent(event, payload);
        if (result instanceof Error) {
          const message = `Failed to track event '${event}'`;
          rollbar.error(message, { error: result, payload });
        }
      },
      [rollbar]
    ),
    trackEventOnce: React.useCallback(
      (event, payload) => {
        const result = trackEvent(event, payload, { once: true });
        if (result instanceof Error) {
          const message = `Failed to track event '${event}'`;
          rollbar.error(message, { error: result, payload });
        }
      },
      [rollbar]
    ),
  };
}
